// TODO generally replace DTOs with ui enums
import {
	HttpErrorResponse,
	HttpHeaders,
	HttpParams,
	HttpResponse
}                                                     from '@angular/common/http';
import { TenantGroupEnum }                            from '@app/modules/admin-tenant/models/tenant.model';
import { ArchivingImportStatusEnum }                  from '@app/modules/archiving/models/archiving-import.model';
import { ArchivingProceduralDocumentationStatusEnum } from '@app/modules/archiving/models/archiving-procedural-documentation.model';
import { OpenArchiveExportStatusEnum }                from '@app/modules/archiving/models/open-archive-export.model';
import { OpenArchiveStatusEnum }                      from '@app/modules/archiving/models/open-archive.model';
import { BusinessPremisesStatusEnum }                 from '@app/modules/business-premises/models/business-premises.model';
import {
	ArchivingContractTypeEnum,
	ContractLogPeriodEnum,
	ContractStatusEnum,
	ContractTypeGroupEnum
}                                                     from '@app/modules/contract/models/contract.model';
import {
	EncryptionKeyStatusEnum,
	KeyScopeEnum
}                                                     from '@app/modules/encryption-key/models/encryption-key.model';
import { ErsStatus }                                  from '@app/modules/ers/models/ers.model';
import { FccVersionStatusEnum }                       from '@app/modules/fcc-version/models/fcc-version.model';
import { FccInstallationTypeEnum }                    from '@app/modules/fcc/models/fcc.model';
import { FiskalExportStatusEnum }                     from '@app/modules/fiskal-tss-log/models/fiskal-tss-log.model';
import { NotificationTargetTypeEnum }                 from '@app/modules/notification/models/notification.model';
import { OutageEventStatusEnum }                      from '@app/modules/outage/models/outage.model';
import { ExportSetModeEnum }                          from '@app/modules/structure-export/models/structure-export.model';
import {
	TaxationReportingFormTypeEnum,
	TaxationReportingStatusEnum
}                                                     from '@app/modules/taxation/taxation-reporting/models/taxation-reporting.model';
import {
	TssPreInitializationModeEnum,
	TssPreInitializationStatusEnum
}                                                     from '@app/modules/tss-pre-initialization/models/tss-pre-initialization.model';
import {
	TssAssignmentTypeEnum,
	TssModeWithSubTypeEnum,
	TssStatus,
	TssStatusEnum
}                                                     from '@app/modules/tss/models/tss.model';
import { PresetType }                                 from '@models/preset';
import {
	TenantStatusEnumDTO,
	TenantTypeEnumDTO
}                                                     from '@openApiGenerated/admin-api';
import {
	ImportStatusEnumDTO,
	PDDocumentTypeDTO
}                                                     from '@openApiGenerated/archiving-api';
import { ExportStatusEnumDTO }                        from '@openApiGenerated/archiving-export-api';
import { ExportSetStatusDTO }                         from '@openApiGenerated/export-api';
import { ImportSetStatusDTO }                         from '@openApiGenerated/import-api';
import { OrganizationStatusEnumDTO }                  from '@openApiGenerated/management-api';
import {
	FilterIdentifiersEnum,
	IActiveFilters
}                                                     from '@shared/list-operations/model/filter.model';
import { IPaging }                                    from '@shared/list-operations/model/paging.model';


export enum ObserveEnum {
	BODY = 'body',
	RESPONSE = 'response',
	EVENTS = 'events',
}


export interface IHttpOptions {
	headers?: HttpHeaders;

	params?: HttpParams;

	reportProgress?: boolean;

	observe?: 'body';

	responseType?: 'json';

	withCredentials?: boolean;
}


export interface IBaseHttpParams {
	activeFilters?: IActiveFilters;
	paging?: IPaging;
	presetId?: PresetType;
	search?: string[];
	sort?: string;
}

export interface IImportHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.STATUS ]?: Array<ImportSetStatusDTO>;
	[ FilterIdentifiersEnum.FILTER ]?: string;
}

export interface IStructureExportHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.EXPORT_MODE ]?: ExportSetModeEnum[];
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: Array<ExportSetStatusDTO>;
}

export interface IKeyHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.STATUS ]?: Array<EncryptionKeyStatusEnum>;
	[ FilterIdentifiersEnum.SCOPE ]?: Array<KeyScopeEnum>;
}

export interface INotificationHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.FROM ]?: Date;
	[ FilterIdentifiersEnum.TO ]?: Date;
	[ FilterIdentifiersEnum.ORGANIZATION_ID ]?: string;
	[ FilterIdentifiersEnum.READ ]?: boolean;
	[ FilterIdentifiersEnum.TARGET_TYPE ]?: NotificationTargetTypeEnum;
	[ FilterIdentifiersEnum.TENANT_ID ]?: string;
}

export interface IOrganizationHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.HAS_ERRORS ]?: boolean;
	[ FilterIdentifiersEnum.HAS_VALIDATION_RESULTS ]?: boolean;
	[ FilterIdentifiersEnum.ORGANIZATION_IDS ]?: string[];
	[ FilterIdentifiersEnum.STATUS ]?: Array<OrganizationStatusEnumDTO>;
	[ FilterIdentifiersEnum.TAXABLE_ENTITY ]?: boolean;
}

/**
 * The UI Interface for Outage search request params
 *
 * @from {Date} UI date type will be mapped to api string type
 * @to {Date} UI date type will be mapped to api string type
 * @hasReason {boolean}
 * @status {OutageEventStatusEnum} UI enum type will be mapped to api enum type
 * @createdDate {Date[]} a ui specific field, which will be mapped to apis 'from' and 'to' fields
 * @includeTotalCount whether to include total count of all outages in whole tenant
 */
export interface IOutageEventHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.FROM ]?: Date;
	[ FilterIdentifiersEnum.TO ]?: Date;
	[ FilterIdentifiersEnum.HAS_REASON ]?: boolean;
	[ FilterIdentifiersEnum.STATUS ]?: Array<OutageEventStatusEnum>;
	[ FilterIdentifiersEnum.FAILED_TIME_PERIOD ]?: Date[];
	[ FilterIdentifiersEnum.INCLUDE_TOTAL_COUNT ]?: boolean;
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.FILTER_BODY ]?: {
		businessPremisesIds?: string[];
		eventIds?: string[];
	};
}

export interface IAdminTenantHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.ARCHIVING_CONTRACT_ID ]?: string;
	[ FilterIdentifiersEnum.CONTRACT_MONTH ]?: string;
	[ FilterIdentifiersEnum.CUSTOMER_IDENTIFIER ]?: string;
	[ FilterIdentifiersEnum.ELSTER_CONTRACT_ID ]?: string;
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.FISCAL_CONTRACT_ID ]?: string;
	[ FilterIdentifiersEnum.REQUIRED_TENANT_ID ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: Array<TenantStatusEnumDTO>;
	[ FilterIdentifiersEnum.TENANT_GROUP ]?: Array<TenantGroupEnum>;
	[ FilterIdentifiersEnum.TENANT_IDS ]?: string[];
	[ FilterIdentifiersEnum.TYPE ]?: Array<TenantTypeEnumDTO>;
}

export interface IAccountTenantHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.ARCHIVING_CONTRACT_ID ]?: string;
	[ FilterIdentifiersEnum.CONTRACT_MONTH ]?: string;
	[ FilterIdentifiersEnum.CUSTOMER_IDENTIFIER ]?: string;
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.FISCAL_CONTRACT_ID ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: Array<TenantStatusEnumDTO>;
	[ FilterIdentifiersEnum.TENANT_IDS ]?: string[];
}


export interface IBusinessPremisesHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_IDS ]?: string[];
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.HAS_ERRORS ]?: boolean;
	[ FilterIdentifiersEnum.HAS_VALIDATION_RESULTS ]?: boolean;
	[ FilterIdentifiersEnum.IS_NOT_YET_TAX_REPORTED ]?: boolean;
	[ FilterIdentifiersEnum.ORGANIZATION_IDS ]?: string[];
	[ FilterIdentifiersEnum.STATUS ]?: BusinessPremisesStatusEnum[];
}

export interface IErsHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.ERS_IDS ]?: string[];
	[ FilterIdentifiersEnum.ERS_SERIAL_NUMBER ]?: string;
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.HAS_VALIDATION_RESULTS ]?: boolean;
	[ FilterIdentifiersEnum.STATUS ]?: ErsStatus[];
}

export interface ITssHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.ASSIGNMENT ]?: TssAssignmentTypeEnum;
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_IDS ]?: string[];
	[ FilterIdentifiersEnum.FCC_ID ]?: string;
	[ FilterIdentifiersEnum.FCC_VERSION ]?: string[];
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.INSTALLATION_TYPE ]?: FccInstallationTypeEnum[];
	[ FilterIdentifiersEnum.MODE ]?: TssModeWithSubTypeEnum[];
	[ FilterIdentifiersEnum.ORGANIZATION_IDS ]?: string[];
	[ FilterIdentifiersEnum.STATUS ]?: TssStatus[];
	[ FilterIdentifiersEnum.TSS_IDS ]?: string[];
}

export interface IUserHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.EMAIL ]?: string;
	[ FilterIdentifiersEnum.FIRST_NAME_SEARCH ]?: string;
	[ FilterIdentifiersEnum.LAST_NAME_SEARCH ]?: string;
	[ FilterIdentifiersEnum.ROLE ]?: string[];
	[ FilterIdentifiersEnum.TENANT_IDS ]?: string[];
	[ FilterIdentifiersEnum.USER_NAME ]?: string;
	[ FilterIdentifiersEnum.USER_NAME_SEARCH ]?: string;
}

export interface IContractHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.CONTRACT_IDS ]?: string[];
	[ FilterIdentifiersEnum.CONTRACT_LOG_PERIOD ]?: ContractLogPeriodEnum[];
	[ FilterIdentifiersEnum.CONTRACT_MONTH ]?: string;
	[ FilterIdentifiersEnum.CONTRACT_TYPE ]?: ArchivingContractTypeEnum[];
	[ FilterIdentifiersEnum.CONTRACT_TYPE_GROUP ]?: ContractTypeGroupEnum[];
	[ FilterIdentifiersEnum.CUSTOMER_NAME ]?: string;
	[ FilterIdentifiersEnum.CUSTOMER_IDENTIFIER ]?: string;
	[ FilterIdentifiersEnum.DATA_CENTER_ENABLED ]?: boolean;
	[ FilterIdentifiersEnum.FCC_DATACENTER_CONTRACT_TYPE_GROUP ]?: ContractTypeGroupEnum[];
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.PROJECT_NUMBER ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: ContractStatusEnum[];
}

export interface IClientHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.ENABLED ]?: boolean;
	[ FilterIdentifiersEnum.MANAGED_OBJECT_ID ]?: string;
	[ FilterIdentifiersEnum.MANAGED_OBJECT_TYPE ]?: string;
	[ FilterIdentifiersEnum.NAME ]?: string;
	[ FilterIdentifiersEnum.NAME_SEARCH ]?: string;
	[ FilterIdentifiersEnum.USER_NAME ]?: string;
	[ FilterIdentifiersEnum.USER_NAME_SEARCH ]?: string;
}


export interface IArchivingErsHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
}

export interface IArchivingExportHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: ExportStatusEnumDTO[];
}

export interface IArchivingExportItemHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.EXPORT_ID ]?: string;
}

export interface IArchivingImportHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.BUSINESS_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.ERS_ID ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: ArchivingImportStatusEnum[];
}

export interface IArchivingKeywordHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.KEYWORD_IDS ]?: string[];
	[ FilterIdentifiersEnum.NAME ]?: string;
}

export interface IArchivingProceduralDocumentHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.DOCUMENT_TYPE ]?: PDDocumentTypeDTO[];
	[ FilterIdentifiersEnum.PROCEDURAL_DOCUMENTATION_ID ]?: string;
}

export interface IArchivingProceduralDocumentationHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]: string;
	[ FilterIdentifiersEnum.NAME ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: ArchivingProceduralDocumentationStatusEnum[];
	[ FilterIdentifiersEnum.VALID_FROM ]?: string;
	[ FilterIdentifiersEnum.VALID_TO ]?: string;
}

export interface IArchivingProceduralDocumentationExportHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: ExportStatusEnumDTO[];
}

export interface IArchivingStatusHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_IDS ]?: string[];
}

export interface IArchivingTssHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
}

export interface IArchivingTssLogHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_DATE ]?: Date[];
	[ FilterIdentifiersEnum.BUSINESS_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.BUSINESS_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.TSS_ID ]?: string;
}

export interface IArchivingTssLogExportHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: ExportStatusEnumDTO[];
}

export interface ICashPointClosingHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.BUSINESS_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.ERS_ID ]?: string;
	[ FilterIdentifiersEnum.IMPORT_ID ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: ImportStatusEnumDTO[];
}


export interface IFccOpenTransactionsHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_IDS ]?: string[];
	[ FilterIdentifiersEnum.FCC_IDS ]?: string[];
	[ FilterIdentifiersEnum.FROM ]?: Date;
	[ FilterIdentifiersEnum.INCLUDE_OVER_MAX ]?: boolean;
	[ FilterIdentifiersEnum.LAST_EVENT_DATE ]?: Date[];
	[ FilterIdentifiersEnum.LAST_EVENT_DATE_FROM ]?: Date;
	[ FilterIdentifiersEnum.LAST_EVENT_DATE_TO ]?: Date;
	[ FilterIdentifiersEnum.ORGANIZATION_IDS ]?: string[];
	[ FilterIdentifiersEnum.STATUS ]?: TssStatusEnum[];
	[ FilterIdentifiersEnum.THRESHOLDS ]?: number[];
	[ FilterIdentifiersEnum.THRESHOLDS_CLOUD ]?: number[];
	[ FilterIdentifiersEnum.THRESHOLDS_OFFLINE ]?: number[];
	[ FilterIdentifiersEnum.THRESHOLDS_TOKEN_CV2 ]?: number[];
	[ FilterIdentifiersEnum.THRESHOLDS_SWISSBIT_TOKEN ]?: number[];
	[ FilterIdentifiersEnum.TO ]?: Date;
	[ FilterIdentifiersEnum.TSS_IDS ]?: string[];
}

export interface IFccVersionHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.FILTER ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: FccVersionStatusEnum[];
}

export interface IFiskalTssLogHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: FiskalExportStatusEnum[];
	[ FilterIdentifiersEnum.TSS_IDS ]?: string[];
}

export interface IFiskalTssLogTenantsAllHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_IDS ]?: string[];
	[ FilterIdentifiersEnum.ORGANIZATION_IDS ]?: string[];
	[ FilterIdentifiersEnum.STATUS ]?: FiskalExportStatusEnum[];
	[ FilterIdentifiersEnum.TSS_IDS ]?: string[];
	[ FilterIdentifiersEnum.UPLOAD_TIME_FROM ]?: Date;
	[ FilterIdentifiersEnum.UPLOAD_TIME_TO ]?: Date;
}

export interface IGlobalStatisticsHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.DATE ]?: Date;
}

export interface IOpenArchiveHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.KEYWORD_IDS ]?: string[];
	[ FilterIdentifiersEnum.NAME ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: OpenArchiveStatusEnum[];
}

export interface IOpenArchiveExportHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_ID ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_FROM ]?: string;
	[ FilterIdentifiersEnum.CREATED_DATE_TO ]?: string;
	[ FilterIdentifiersEnum.STATUS ]?: OpenArchiveExportStatusEnum[];
}

export interface ITaxationReportingHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.BUSINESS_PREMISES_IDS ]?: string[];
	[ FilterIdentifiersEnum.FORM_TYPE ]?: TaxationReportingFormTypeEnum;
	[ FilterIdentifiersEnum.IS_DOWNLOADED ]?: boolean;
	[ FilterIdentifiersEnum.ORGANIZATION_IDS ]?: string[];
	[ FilterIdentifiersEnum.STATUS ]?: TaxationReportingStatusEnum[];
}

export interface ITenantTransactionStatisticsHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.DATE ]?: Date;
}

export interface ITssPreInitializationHttpParams extends IBaseHttpParams {
	[ FilterIdentifiersEnum.MODE ]?: TssPreInitializationModeEnum[];
	[ FilterIdentifiersEnum.STATUS ]?: TssPreInitializationStatusEnum[];
}


export enum RequestState {
	NO_RESULT = 'noResult',
	NOT_ASKED = 'notAsked',
	NOT_SUPPORTED = 'notSupported',
	PENDING = 'pending',
	SUCCESS = 'success',
	FAILED = 'failed',
	FAILED_REQUEST_PRE_VALIDATION = 'failedRequestPreValidation',
	HTTP_EVENT = 'httpEvent',
	UNKNOWN = 'unknown',
}

export enum RequestActionEnum {
	CREATE = 'create',
	CONFIRM = 'confirm',
	DELETE = 'delete',
	DOWNLOAD = 'download',
	EXPORT = 'export',
	EXTEND = 'extend',
	INFO = 'info',
	LIST = 'list',
	PATCH = 'patch',
	/** unspecific POST request */
	POST = 'post',
	READ = 'read',
	UPDATE = 'update',
	UPLOAD = 'upload',
	SYNC = 'sync',
}

export interface RequestCompleteBaseState<T> {
	action: RequestActionEnum;
	debug?: { message: string, response: any };
	error?: HttpErrorResponse;
	httpResponse?: HttpResponse<T>;
	requestState: RequestState;
}

export interface RequestCompleteListState<T> extends RequestCompleteBaseState<T> {
	list: T[];
	paging: IPaging;
	totalCount?: number;
}

export interface RequestCompleteEntityState<T> extends RequestCompleteBaseState<T> {
	entity: T;
}
